"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.augmentGeofence = augmentGeofence;
exports.boundsOfPolygon = boundsOfPolygon;
exports.boundsOfRectangle = boundsOfRectangle;
exports.getGMapsURL = getGMapsURL;
exports.getMapAssets = getMapAssets;
exports.initializeGMapsURL = initializeGMapsURL;
exports.isAssetInBounds = isAssetInBounds;
exports.setGMapsURL = setGMapsURL;
exports.unifyCoordinates = unifyCoordinates;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _immutable = _interopRequireWildcard(require("immutable"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function boundsOfPolygon(polygon, aGoogle) {
  let bounds = new aGoogle.maps.LatLngBounds();
  if (!('getPaths' in polygon) && (0, _isArray.default)(polygon)) {
    polygon = new aGoogle.maps.Polygon({
      paths: polygon
    });
  }
  let paths = polygon.getPaths();
  for (var i = 0; i < paths.getLength(); i++) {
    var path = paths.getAt(i);
    for (var j = 0; j < path.getLength(); j++) {
      bounds.extend(path.getAt(j));
    }
  }
  return bounds;
}
function boundsOfRectangle(bounds, aGoogle) {
  return new aGoogle.maps.LatLngBounds({
    lat: bounds.south,
    lng: bounds.west
  }, {
    lat: bounds.north,
    lng: bounds.east
  });
}

//TODO - FOLD THIS INTO genGeoFenceDefSelector AND sharedGeoFenceSelectors
function augmentGeofence(geofence) {
  //explicitly test for each case to prevent null errors
  if (geofence.bounding_polygon) {
    unifyCoordinates(geofence.bounding_polygon);
    geofence.center = boundsOfPolygon(geofence.bounding_polygon, google).getCenter().toJSON();
  } else if (geofence.bounding_box) {
    geofence.center = boundsOfRectangle(geofence.bounding_box, google).getCenter().toJSON();
  } else if (geofence.bounding_circle) {
    // must be a circular geo-fence
    const bCir = unifyCoordinates(geofence.bounding_circle.center);
    geofence.center = {
      lat: bCir.lat,
      lng: bCir.lng
    };
  }
  return geofence;
}
function getMapAssets(assets) {
  var _context;
  const filteredAssets = _immutable.default.List().asMutable();
  (0, _forEach.default)(_context = (0, _filter.default)(assets).call(assets, v => v.has('location') && v.get('location').has('lat') && v.get('location').has('lon'))).call(_context, v => filteredAssets.push(
  // Filter only the fields we want
  (0, _immutable.fromJS)({
    location: v.get('location'),
    vehicle_id: v.get('vehicle_id')
  })));
  return filteredAssets.asImmutable();
}
function convertCoordinate(coord) {
  if (typeof coord.lng === 'undefined') {
    coord.lng = coord.lon;
  } else if (typeof coord.lon === 'undefined') {
    coord.lon = coord.lng;
  }
  return coord;
}
function unifyCoordinates(coordinates) {
  if ((0, _isArray.default)(coordinates)) {
    return (0, _map.default)(coordinates).call(coordinates, convertCoordinate);
  } else {
    return convertCoordinate(coordinates);
  }
}
function isAssetInBounds(asset, bounds, containsLocation, myGoogle) {
  if (asset.has('location')) {
    let aLoc = asset.get('location').toJS();
    if ('lat' in aLoc && 'lon' in aLoc) {
      let assetLoc = new myGoogle.maps.LatLng(aLoc.lat, aLoc.lon);
      return containsLocation(assetLoc, bounds);
    }
    return false;
  }
  return false;
}
let auGMapsURL = null;

/*
 * For typical UI needs and gmaps libraries needed, initializeGMapsURL will
 * set the appropriate URL when an apiKey is provided.
 */
function initializeGMapsURL(apiKey) {
  setGMapsURL('https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&v=3.exp&libraries=geometry,drawing');
}

/*
 * Sets the URL that will be used for loading google maps javascript library.
 * It will take whatever is handed to it.
 */
function setGMapsURL(url) {
  auGMapsURL = url;
}
function getGMapsURL() {
  return auGMapsURL;
}